import Modal from 'bootstrap/js/dist/modal';

class AgeGate {
  private modalElement: HTMLElement | null;
  private modalInstance: Modal | null = null;
  private form: HTMLFormElement | null;
  private errorMessage: HTMLElement | null;
  private rememberCheckbox: HTMLInputElement | null;

  constructor() {
    this.modalElement = document.getElementById('legalModal');
    this.form = document.getElementById('ageForm') as HTMLFormElement | null;
    this.errorMessage = document.getElementById('errorMessage');
    this.rememberCheckbox = document.getElementById('rememberMe') as HTMLInputElement | null;

    if (!this.modalElement) return;

    this.modalInstance = new Modal(this.modalElement, {
      backdrop: 'static',
      keyboard: false,
    });

    this.init();
  }

  private init(): void {
    this.handleAutoOpen();
    this.handleFormSubmit();
  }

  private handleAutoOpen(): void {
    if (sessionStorage.getItem('ageVerified')) {
      this.dispatchReady();
      return;
    }

    const stored = localStorage.getItem('ageVerified');

    if (stored) {
      try {
        const { expiry } = JSON.parse(stored);
        if (expiry === null || Date.now() < expiry) {
          this.dispatchReady();
          return;
        }
      } catch {
        localStorage.removeItem('ageVerified');
      }
      localStorage.removeItem('ageVerified');
    }

    this.modalElement?.addEventListener('hidden.bs.modal', () => {
      this.dispatchReady();
    }, { once: true });

    if (this.modalInstance) {
      this.modalInstance.show();
    }
  }

  private handleFormSubmit(): void {
    this.form?.addEventListener('submit', (e: Event) => {
      e.preventDefault();

      const dayInput = document.getElementById('day') as HTMLInputElement;
      const monthInput = document.getElementById('month') as HTMLInputElement;
      const yearInput = document.getElementById('year') as HTMLInputElement;

      const day = parseInt(dayInput.value);
      const month = parseInt(monthInput.value) - 1;
      const year = parseInt(yearInput.value);

      if (!this.isValidDate(day, month, year)) {
        this.showError(true);
        return;
      }

      const age = this.calculateAge(new Date(year, month, day));

      if (age >= 18) {
        this.onSuccess();
      } else {
        this.showError(true);
      }
    });
  }

  private calculateAge(birthDate: Date): number {
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();

    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    return age;
  }

  private isValidDate(day: number, month: number, year: number): boolean {
    const date = new Date(year, month, day);

    return (
      date.getFullYear() === year &&
      date.getMonth() === month &&
      date.getDate() === day
    );
  }

  private onSuccess(): void {
    this.modalInstance?.hide();

    if (this.rememberCheckbox?.checked) {
      localStorage.setItem('ageVerified', JSON.stringify({ expiry: null }));
    } else {
      sessionStorage.setItem('ageVerified', 'true');
    }
  }

  private showError(show: boolean): void {
    if (!this.errorMessage) return;

    this.errorMessage.style.display = show ? 'block' : 'none';
  }

  private dispatchReady(): void {
    window.dispatchEvent(new CustomEvent('agegate:ready'));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new AgeGate();
});